import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import './StudyCreate.css';

const StudyCreate = () => {
  const [formData, setFormData] = useState({
    study_instance_id: '',
    patient: '', // Usually a UUID
    uploader: '', // Possibly an integer user ID
  });
  const [patientPrefilled, setPatientPrefilled] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const token = localStorage.getItem('token');
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const patientId = searchParams.get('patient');
    if (patientId) {
      setFormData((prev) => ({ ...prev, patient: patientId }));
      setPatientPrefilled(true);
    }
  }, [location.search]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/patients/studies/create/`,
        formData,
        { headers: { Authorization: `Token ${token}` } }
      );
      setSuccess(true);
      setError('');
      setFormData({
        study_instance_id: '',
        patient: '',
        uploader: '',
      });
    } catch (err) {
      console.error(err);
      setError('Error creating Study. Check fields or try again.');
      setSuccess(false);
    }
  };

  return (
    <div className="study-create-container">
      <h3>Create New Study</h3>
      {error && <p className="error-message">{error}</p>}
      {success && <p className="success-message">Study created successfully!</p>}

      <form onSubmit={handleSubmit} className="study-create-form">
        <div className="form-group">
          <label>Study Instance ID  <span className="required-asterisk">*</span></label>
          <input
            type="text"
            name="study_instance_id"
            value={formData.study_instance_id}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Patient (UUID)  <span className="required-asterisk">*</span></label>
          <input
            type="text"
            name="patient"
            value={formData.patient}
            onChange={handleChange}
            placeholder="Patient UUID"
            required
            disabled={patientPrefilled}
          />
        </div>
        <button type="submit" className="study-create-btn">
          Create Study
        </button>
      </form>
    </div>
  );
};

export default StudyCreate;
